<template>
  <div>
    <div class="row">
      <div class="col-8">
        <form>
          <div v-for="phoenix_setting in filtered_phoenix_settings" :key="phoenix_setting.phoenix_setting_id">
            <div class="form-group row" v-if="phoenix_setting.setting === 'DOMAIN'">
              <label for="txtDomain" class="col-3 col-form-label">Domain</label>
              <div class="col-9">
                <input type="text" class="form-control" id="txtDomain" v-model="phoenix_setting.value">
              </div>
            </div>
            <div class="form-group row" v-if="phoenix_setting.setting === 'EXTERNAL_RTP_IP'">
              <label for="txtExternalRtpIp" class="col-3 col-form-label">External RTP IP</label>
              <div class="col-9">
                <input type="text" class="form-control" id="txtExternalRtpIp" v-model="phoenix_setting.value">
              </div>
            </div>
            <div class="form-group row" v-if="phoenix_setting.setting === 'EXTERNAL_SIP_IP'">
              <label for="txtExternalSipIp" class="col-3 col-form-label">External SIP IP</label>
              <div class="col-9">
                <input type="text" class="form-control" id="txtExternalSipIp" v-model="phoenix_setting.value">
              </div>
            </div>
          </div>
          <button type="button" class="btn btn-hub-primary" @click="submit()">Save</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      phoenix_settings: 'allPhoenixSettings',
      logged_in_user: 'loggedInUser',
      scoped_site_id: 'scopedSiteId'
    }),
    filtered_phoenix_settings: function () {
      return this.phoenix_settings.filter(ps => ps.site_id === this.scoped_site_id)
    }
  },
  created () {
    this.$store.dispatch('setDisabledChangeScopedSite', true)
    this.$store.dispatch('getPhoenixSettings', 'PHOENIX.INTERCOM.VARS')
  },
  methods: {
    submit () {
      this.$store.dispatch('editPhoenixSettings', this.phoenix_settings)
    }
  }
}
</script>

<style scoped>

</style>
